
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {PosAppMdmFqOutput,PosLoginResult} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : {id:835687644235} ,
    formdata:{},
    labelWidth:100 ,
    items:
    [
        {lable:'项目ID',field:'id',placeholder:'number类型'},
    ]
} ;

let outputExample = {
    code: 200,
    msg: "",
    data: [
        {
            sapId: "P0231-01",
            name: "杭州海盐天峻",
            ldList: [
                {
                    sapId: "P0231-01-001",
                    name: "1#",
                    fqSapId: "P0231-01"
                },
                {
                    sapId: "P0231-01-002",
                    name: "2#",
                    fqSapId: "P0231-01"
                }
            ]
        }
    ]
} as PosAppMdmFqOutput

export const AppGetFqList = () =>{

    const[outputResult,setOutputResult]  = useState(null as PosAppMdmFqOutput[])
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        let res = await api.posapp.getFqList(inputParam);
        setOutputResult(res);
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return renderOutputForm();
            case 1:
            return renderOutputfqInfoTable();
            case 2:
            return renderJson();
        }

        return '';
    }

    const renderOutputForm = () =>{
        return ( <AppForm  loadingData={false} formData={{...outputResult}}>
            <AppForm.Section labelWidth={150}>
                <AppForm.Item label='状态码（code）:' field='code' itemType='input' readonly/>
                <AppForm.Item label='信息（msg）:' field='msg' itemType='input' readonly/>
            </AppForm.Section>
        </AppForm>)
    }

    const renderOutputfqInfoTable = () =>{
        let list = null;
        if(outputResult&&outputResult){
            list = outputResult
        }
        if(list){
            return ( <AppTable  dataSource={list}>
               <AppTable.ColIndex />
               <AppTable.Col field='sapId' width={100}/>
               <AppTable.Col field='fqSapId' />
            </AppTable>)
        }else{
            return null;
        }
       
    }

    const renderOutputLdInfoTable  = (posAppMdmFqOutput:PosAppMdmFqOutput) =>{
        if(posAppMdmFqOutput&&posAppMdmFqOutput.ldList){
            return ( <AppTable  dataSource={posAppMdmFqOutput.ldList}>
               <AppTable.ColIndex />
               <AppTable.Col field='sapId' width={100}/>
               <AppTable.Col field='name' />
               <AppTable.Col field='name' />
            </AppTable>)
        }else{
            return null;
        }
    }

    const renderJson = () =>{
        return <pre>{JSON.stringify(outputResult, null, 4)}</pre>
    } 
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>PosApp获取分期及楼栋信息</h1>    
            <div>
                1、Pos端登录使用<br/>
                2、地址：/api/posApp/getFqList <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['表单（LoginResult）','列表（楼栋）','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/AppGetFqList.tsx